
import { Component, ComponentRef, ViewChild, ViewContainerRef } from '@angular/core';
import { ModalStackItem } from '@app/core/services/core-modal.service';
import { CoreModalItemComponent } from './core-modal-item/core-modal-item.component';
import { shareReplay, Subject } from 'rxjs';

@Component({
  selector: 'core-modal-container',
  templateUrl: './core-modal-container.component.html',
  styleUrls: ['./core-modal-container.component.scss'],

})
export class CoreModalContainerComponent {
  @ViewChild('vc', { read: ViewContainerRef, static: true })
  vc!: ViewContainerRef;
  private allClosedSubject = new Subject<void>();
  onAllClosed$ = this.allClosedSubject.asObservable().pipe(shareReplay(1));

  private refs: ComponentRef<any>[] = [];

  push(item: ModalStackItem) {
    const ref = this.vc.createComponent(CoreModalItemComponent);

    ref.instance.item = item;
    ref.changeDetectorRef.detectChanges();

    this.refs.push(ref);
  }

  pop() {
    const ref = this.refs.pop();
    if (!ref) return;
    ref.instance.destroy(() => {
      ref.destroy();
      this.checkAllClosed();
    });
  }

  removeAt(index: number) {
    const ref = this.refs[index];
    if (!ref) return;
    ref.instance.destroy(() => {
      ref.destroy();
      this.refs.splice(index, 1);
      this.checkAllClosed();
    });
  }

  clear() {
    this.refs.forEach(r => r.destroy());
    this.refs = [];
    this.checkAllClosed();
  }

  get length() {
    return this.refs.length;
  }

  private checkAllClosed() {
    if (this.length === 0) {
      this.allClosedSubject.next();
    }
  }

  updateActiveStates(stack: ModalStackItem[]) {
    this.refs.forEach((ref, i) => {
      ref.instance.setActive(stack[i].isActive);
    });
  }
}